import styled from 'styled-components';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const PANEL_BODY_PADDING = '24px';

const StyledTransactionDetailsPanel = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const StyledTransactionDetailsPanelContainer = styled.div`
  position: ${props => props.fixed ? 'fixed' : 'relative'};
  top: ${props => props.fixed ? '90px' : '0px'};
  width: inherit;

  & > div {
    transition: opacity .3s ease;
  }
`;

const StyledTransactionDetailsPanelContent = styled.div`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};
  margin-left: 24px;
`;

const StyledTransactionDetailsPanelBody = styled.div`
  padding: ${PANEL_BODY_PADDING};
  overflow: auto;
  max-height: calc(100vh - (66px + ${PANEL_BODY_PADDING} * 2 + 56px));
`;

const StyledTransactionDetailsPanelHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.neutral_4};
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  padding: 0 24px;
  min-height: 56px;

  button.ant-btn {
    ${typographyStyles.heading.h5};
    align-items: center;
    color: ${props => props.theme.colors.neutral_10};
    display: flex;
    border: none;
    margin-right: 8px;
    padding: 0 7px 0 0;

    svg {
      path {
        transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        fill: ${props => props.theme.colors.neutral_6};
        stroke: ${props => props.theme.colors.neutral_6};
      }
    }

    &:hover {
      svg {
        path {
          fill: rgba(0, 0, 0, 0.88);
          stroke: rgba(0, 0, 0, 0.88);
        }
      }
    }
  }
`;

const StyledTransactionDetailsPanelFooter = styled.div`
  align-items: center;
  border-top: 1px solid ${props => props.theme.colors.neutral_4};
  display: flex;
  justify-content: end;
  padding: 16px 24px;
`;

const StyledTransactionDetailsPanelHeaderText = styled.div`
  ${typographyStyles.heading.h5};
`;

export {
  StyledTransactionDetailsPanel,
  StyledTransactionDetailsPanelContainer,
  StyledTransactionDetailsPanelContent,
  StyledTransactionDetailsPanelBody,
  StyledTransactionDetailsPanelHeader,
  StyledTransactionDetailsPanelHeaderText,
  StyledTransactionDetailsPanelFooter,
};
